import React from "react";
import PropTypes from "prop-types";
import SellOutNiveaDesktop from "./SellOutNiveaDesktop";

function SellOutNivea({ app, config }) {
  return <SellOutNiveaDesktop app={app} config={config} pdvTitle="Sell Thru NIVEA + PDV" />;
}

SellOutNivea.defaultProps = {
  app: null,
  config: {},
};

SellOutNivea.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default SellOutNivea;
